import type {
  TypeSTTConfig,
  TypeSTTConfigForm,
} from "@intone/shared";

export const mapToForm = (config?: TypeSTTConfig ): TypeSTTConfigForm => {
  return {
    name: config?.name ?? 'Default',
    provider: config?.provider ?? 'deepgram',
    model: config?.model ?? 'nova-3',
    language: config?.language ?? 'en',
    use_filler_words: config?.use_filler_words ?? true,
    detect_language: config?.detect_language ?? false,
    interim_results: config?.interim_results ?? true,
    punctuate: config?.punctuate ?? true,
    numerals: config?.numerals ?? false,
    smart_format: config?.smart_format ?? false,
    spoken_punctuation: config?.spoken_punctuation ?? false,
    profanity_filter: config?.profanity_filter ?? false,
    enable_diarization: config?.enable_diarization ?? false,
    explicit_punctuation: config?.explicit_punctuation ?? false,
    enable_word_time_offsets: config?.enable_word_time_offsets ?? false,
    enable_word_confidence: config?.enable_word_confidence ?? false,
    enable_voice_activity_events: config?.enable_voice_activity_events ?? false,
    energy_filter: config?.energy_filter ?? false,
    endpointing_ms: config?.endpointing_ms ?? 25,
    min_confidence_threshold: config?.min_confidence_threshold ?? 0.65,
    keywords: config?.keywords ?? null,
    keyterms: config?.keyterms ?? [],
    phrase_list: config?.phrase_list ?? [],
    prompt: config?.prompt ?? null,
    noise_reduction: config?.noise_reduction ?? null,
  }
};